import { useEffect } from 'react'

const AdditionalInfoQuestion = ({ requestData, formData, setFormData }) => {
    useEffect(() => {
        if (requestData && !requestData.v2 && requestData.request_info_array?.form_responses?.question6) {
            const legacyQuestion6 = requestData.request_info_array.form_responses.question6.responses

            if (legacyQuestion6.additionalInfo?.value) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    form_responses: {
                        ...prevFormData.form_responses,
                        question7: {
                            question_title: 'Additional Information',
                            responses: {
                                additional_info: {
                                    label: 'Additional Information',
                                    value: legacyQuestion6.additionalInfo.value
                                }
                            }
                        }
                    }
                }))
            }
        }
    }, [requestData])

    return (
        <div className="mt-6 border border-gray-200 rounded-lg">
            <div className="flex items-center justify-between p-4 bg-blue-50 rounded-t-lg">
                <h2 className="text-lg font-semibold text-gray-800">
                    Step 7: Supporting Documents & Additional Information
                </h2>
            </div>
            <div className="p-4">
                <label htmlFor="additionalInfo" className="block text-sm font-medium text-gray-700 mb-2">
                    Please provide any supplementary information for the referral, including any specific questions for assessment and additional context to help the team
                </label>
                <textarea
                    id="additionalInfo"
                    name="additionalInfo"
                    rows="4"
                    className="border rounded-md py-2 px-4 w-full resize-vertical"
                    placeholder="Please provide any additional information that may be relevant..."
                    onChange={(e) => setFormData({
                        ...formData,
                        form_responses: {
                            ...formData.form_responses,
                            question7: {
                                ...formData.form_responses.question7,
                                responses: {
                                    ...formData.form_responses.question7.responses,
                                    additional_info: {
                                        ...formData.form_responses.question7.responses.additional_info,
                                        value: e.target.value
                                    }
                                }
                            }
                        }
                    })}
                    value={formData.form_responses?.question7?.responses?.additional_info?.value || ''}
                ></textarea>
            </div>
        </div>
    );
};

export default AdditionalInfoQuestion;